import { useCallback, useMemo, useState } from "react";
import Modal from "../../../components/modal";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import SalesBillVariantPosModel from "./sales_variant_model";
import CreatableDropdown from "../pos/creatableDropdown";


const OtherClaimModal = ({ show, onClose, bill, onSubmit }) => {
    const [reason, setReason] = useState('');
    const [claimType, setClaimType] = useState('exchange'); // 'exchange' or 'refund'
    const [modeOfPayment, setModeOfPayment] = useState('cash');
    const [returnAmount, setReturnAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedProductVariant, setSelectedProductVariant] = useState(null);

    const [selectedSerial, setSelectedSerial] = useState({});
    const [variantProduct, setVariantProduct] = useState([]);
    const [showVariantModel, setshowVariantModel] = useState(false);
    const purchaseDate = moment(bill?.createdAt);
    const currentDate = moment();
    const daysDifference = currentDate.diff(purchaseDate, 'days');

    const [selectedOldSerials, setSelectedOldSerials] = useState([]);
    const [newVariants, setNewVariants] = useState([]);

    const [form, setForm] = useState({
        product_type: "AB-OS",
        product_for: "M",
        product_name: "",
        serial_no: "",        // ✅ FIXED
        product_size: [],
        product_color: [],
        product_price: "",
        product_tax: "12"
    });


    /* =====================
       OLD SERIALS
    ======================*/
    const allOldSerials = useMemo(() => {
        if (!bill?.product_data) return [];

        return bill.product_data.flatMap(p =>
            p.serial_nos.map(s => ({
                row_key: `${p.product_id}_${s.serial_no}`,
                product_id: p.product_id,
                product_name: p.product_name,
                product_type: p.product_type,     // ✅ ADD
                product_for: p.product_for,       // ✅ ADD
                price: Number(p.price),
                gst: p.gst,
                gst_included: p.gst_included,
                variant_id: s.variant_id,
                serial_no: s.serial_no
            }))
        );
    }, [bill]);



    /* =====================
       HANDLERS
    ======================*/
    const toggleOldSerial = (serial) => {
        setSelectedOldSerials(prev => {
            const exists = prev.find(s => s.row_key === serial.row_key);
            if (exists) {
                return prev.filter(s => s.row_key !== serial.row_key);
            }
            return [...prev, serial];
        });
        setNewVariants([]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSizeSelect = (v) => {
        setForm(prev => ({ ...prev, product_size: v }));
    };

    const handleColorSelect = (v) => {
        setForm(prev => ({ ...prev, product_color: v }));
    };

    /* =====================
       ADD MANUAL PRODUCT
    ======================*/
    const addManualProduct = () => {
        if (!form.product_name || !form.product_price || !form.serial_no) {
            alert("Product name, serial & price required");
            return;
        }

        if (newVariants.length >= selectedOldSerials.length) {
            alert("Cannot add more products than selected old serials");
            return;
        }

        const item = {
            product_id: `OTHER_${Date.now()}`,
            product_name: form.product_name,
            product_type: form.product_type,   // ✅ ADD
            product_for: form.product_for,     // ✅ ADD
            price: Number(form.product_price),
            gst: form.product_tax,
            gst_included: true,
            serial_no: form.serial_no,
            variant_id: `TMP_${Date.now()}`
        };

        setNewVariants(prev => [...prev, item]);

        setForm(prev => ({
            ...prev,
            serial_no: "",
            product_price: ""
        }));
    };


    /* =====================
       TOTALS
    ======================*/
    const oldTotal = selectedOldSerials.reduce((s, i) => s + i.price, 0);
    const newTotal = newVariants.reduce((s, i) => s + i.price, 0);
    const diff = newTotal - oldTotal;

    /* =====================
       FINAL PRODUCT DATA
    ======================*/
    const buildFinalProductData = () => {
        const remainingOld = allOldSerials.filter(
            o => !selectedOldSerials.some(s => s.row_key === o.row_key)
        );

        const finalItems = [...remainingOld, ...newVariants];

        const grouped = {};


        finalItems.forEach(item => {
            const key = `${item.product_id}_${item.price}_${item.gst}_${item.gst_included}`;

            if (!grouped[key]) {
                grouped[key] = {
                    product_id: item.product_id,
                    product_name: item.product_name,
                    gst: item.gst,
                    gst_included: true,
                    product_type: item.product_type,   // ✅ ADD
                    product_for: item.product_for,
                    price: item.price,
                    qty: 0,
                    amount: 0,
                    serial_nos: []
                };
            }

            grouped[key].qty += 1;
            grouped[key].amount += item.price;
            grouped[key].serial_nos.push({
                serial_no: item.serial_no,
                variant_id: item.variant_id
            });
        });

        return Object.values(grouped);
    };


    /* =====================
       CONFIRM
    ======================*/
    const confirmExchange = async () => {
        const company = JSON.parse(localStorage.getItem("company"));
        const companyId = company?.company?.id;

        const payload = {
            sale_bill_id: bill.id,
            product_data: buildFinalProductData(),
            removed_variants: selectedOldSerials.map(s => ({
                variant_id: s.variant_id,
                serial_no: s.serial_no
            })),
            price_difference: diff
        };

        console.log('payload ', payload);

        try {
            await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);
            alert("Exchange completed");
            window.location.reload();
            onClose();
        } catch (err) {
            console.error(err);
            alert("Something went wrong");
        }
    };

    const handleReset = () => {
        setReason('');
        setClaimType('exchange');
        setModeOfPayment('cash');
        setSelectedSerial({});
    };


    const handleSubmit = async () => {
        if (!reason.trim()) {
            Swal.fire('Error!', 'Please enter a reason for the claim.', 'error');
            return;
        }

        setLoading(true);
        try {
            await onSubmit({
                variants_details: selectedOldSerials.map(s => ({
                    variant_id: s.variant_id,
                    serial_no: s.serial_no
                })),
                bill_no: bill.id,
                reason: reason,
                type: claimType,
                mode_of_payment: modeOfPayment,
                amount: returnAmount || 0,
            });
            handleReset();
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Modal show={show} onClose={() => { handleReset(); onClose(); }} heading="Process Claim" size="lg">
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label"><strong>Bill No:</strong></label>
                            <p>{bill?.bill_no}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Purchase Date:</strong></label>
                            <p>{purchaseDate.format('DD-MM-YYYY')}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Days Since Purchase:</strong></label>
                            <p className={daysDifference > 30 ? 'text-danger fw-bold' : 'text-success'}>
                                {daysDifference} days {daysDifference > 30 ? '(Exceeded 30 days)' : '(Within warranty period)'}
                            </p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label"><strong>Customer:</strong></label>
                            <p>{bill?.Customer?.name || 'Walk-in Customer'}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Total Amount:</strong></label>
                            <p>₹{bill?.total?.toFixed(2)}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Products:</strong></label>
                            <div style={{ maxHeight: '80px', overflowY: 'auto' }}>
                                {bill?.product_data?.map((p, i) => (
                                    <small key={i} className="d-block">
                                        {p.product_name} - ₹{p.amount}
                                    </small>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="mb-3">
                            <label className="form-label"><strong>Select Product</strong></label><br />
                            {allOldSerials.map(s => (
                                <button
                                    key={s.row_key}   // ✅ FIXED
                                    className={`btn me-2 mb-2 ${selectedOldSerials.some(x => x.row_key === s.row_key)
                                        ? "btn-danger"
                                        : "btn-outline-secondary"
                                        }`}
                                    onClick={() => toggleOldSerial(s)}
                                >
                                    {s.product_name}
                                    <br />
                                    <small>{s.serial_no}</small>
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="mb-3">
                            <label className="form-label"><strong>Claim Reason:</strong></label>
                            <textarea
                                className="form-control"
                                placeholder="Enter reason for claim (e.g., defect, size issue, color mismatch)..."
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                rows="3"
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label"><strong>Claim Type:</strong></label>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    id="exchange"
                                    value="exchange"
                                    checked={claimType === 'exchange'}
                                    style={{ borderRadius: '2px' }}
                                    onChange={(e) => setClaimType(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="exchange">
                                    Exchange for Different Product
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="refund"
                                    value="refund"
                                    style={{ borderRadius: '2px' }}
                                    checked={claimType === 'refund'}
                                    onChange={(e) => setClaimType(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="refund">
                                    Refund Money Back
                                </label>
                            </div>
                        </div>
                    </div>

                    {claimType === 'exchange' && (
                        <>
                            {selectedOldSerials.length > 0 && (
                                <>
                                    <hr />

                                    {/* MANUAL FORM */}
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label>Product Type</label>
                                            <select
                                                name="product_type"
                                                value={form.product_type}
                                                onChange={handleChange}
                                                className="form-control"
                                            >
                                                <option value="AB-OS">AB OS</option>
                                                <option value="AB-SS">AB SS</option>
                                            </select>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label>Product For</label>
                                            <select
                                                name="product_for"
                                                value={form.product_for}
                                                onChange={handleChange}
                                                className="form-control"
                                            >
                                                <option value="M">Men</option>
                                                <option value="W">Women</option>
                                                <option value="K">Kids</option>
                                            </select>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label>Product Name</label>
                                            <input
                                                name="product_name"
                                                value={form.product_name}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label>Article No.</label>
                                            <input
                                                name="product_serial"
                                                value={form.product_serial}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <CreatableDropdown
                                                label="Size"
                                                value={form.product_size}
                                                onChange={handleSizeSelect}
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <CreatableDropdown
                                                label="Color"
                                                value={form.product_color}
                                                onChange={handleColorSelect}
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label>Serial Number</label>
                                            <input
                                                name="serial_no"
                                                value={form.serial_no}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>


                                        <div className="col-md-4 mb-3">
                                            <label>Price</label>
                                            <input
                                                type="number"
                                                name="product_price"
                                                value={form.product_price}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label>Tax (%)</label>
                                            <input
                                                type="number"
                                                name="product_tax"
                                                value={form.product_tax}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <button className="btn btn-primary mb-3" onClick={addManualProduct}>
                                        Add Product
                                    </button>
                                </>
                            )}

                            {/* NEW PRODUCTS */}
                            {newVariants.length > 0 && (
                                <>
                                    <h6>New Products ({newVariants.length}/{selectedOldSerials.length})</h6>
                                    <table className="table table-bordered">
                                        <tbody>
                                            {newVariants.map((v, i) => (
                                                <tr key={v.variant_id}>
                                                    <td>{i + 1}</td>
                                                    <td>{v.product_name}</td>
                                                    <td>{v.serial_no}</td>
                                                    <td>₹{v.price}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() =>
                                                                setNewVariants(prev =>
                                                                    prev.filter(x => x.variant_id !== v.variant_id)
                                                                )
                                                            }
                                                        >
                                                            Remove
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            )}

                            {/* PRICE DIFF */}
                            {selectedOldSerials.length > 0 && (
                                <>
                                    {diff > 0 && <div className="alert alert-warning">Add ₹{diff}</div>}
                                    {diff < 0 && <div className="alert alert-info">Return ₹{Math.abs(diff)}</div>}
                                </>
                            )}

                            <div className="d-flex justify-content-end gap-2 mt-3">

                                <button type="button" className="btn btn-secondary" onClick={() => {
                                    setNewVariants([]);
                                    onClose();
                                }}>Close</button>


                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={newVariants.length === 0}
                                    onClick={async () => {
                                        if (!reason.trim()) {
                                            Swal.fire('Error!', 'Please enter a reason for the claim.', 'error');
                                            return;
                                        }
                                        const company = JSON.parse(localStorage.getItem("company"));
                                        const companyId = company?.company?.id;
                                    
                                        const payload = {
                                            sale_bill_id: bill.id,
                                            product_data: buildFinalProductData(),
                                            removed_variants: selectedOldSerials.map(s => ({
                                            variant_id: s.variant_id,
                                            serial_no: s.serial_no
                                            })),
                                            price_difference: diff
                                        };
                                    
                                        console.log('payload ', payload);
                                    
                                        try {
                                            await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);
                                            handleSubmit();
                                        } catch (err) {
                                            console.error(err);
                                            Swal.fire('Error!', 'Error processing claim.', 'error');
                                        }
                                    }}
                                // onClick={async () => {
                                //     // Call API with selectedSerial.variant_id and selectedProductVariant
                                //     try {
                                //         const company = JSON.parse(localStorage.getItem('company'));
                                //         const companyId = company?.company?.id;
                                //         const payload = {
                                //             sale_bill_id: bill.id,
                                //             old_variant_id: selectedSerial.serial,
                                //             new_product: selectedProductVariant,
                                //             product_key: selectedSerial.product_key
                                //         };
                                //         await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);
                                //         alert('Re-allocation successful!');
                                //         onClose();
                                //     } catch (err) {
                                //         alert('Re-allocation failed!');
                                //     }
                                // }}
                                >
                                    Confirm & Exchange
                                </button>
                            </div>
                        </>
                    )}

                    {claimType === 'refund' && (
                        <>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label"><strong>Amount Returned <span className="badge bg-success">(Difference {diff})</span></strong></label>
                                    <input type="number" className="form-control" value={returnAmount} max={Math.abs(diff)} onChange={(e) => setReturnAmount(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label"><strong>Mode of Payment (Refund):</strong></label>
                                    <select
                                        className="form-select"
                                        value={modeOfPayment}
                                        onChange={(e) => setModeOfPayment(e.target.value)}
                                    >
                                        <option value="Cash">Cash</option>
                                        <option value="Gpay UPI">Gpay UPI</option>
                                        <option value="Phonepe upi">Phonepe upi</option>
                                        <option value="Paytm upi">Paytm upi</option>
                                        <option value="Bharat pay upi">Bharat pay upi</option>
                                        <option value="Debit card">Debit card</option>
                                        <option value="Credit card">Credit card</option>
                                        <option value="Bhim upi">Bhim upi</option>
                                        <option value="Amazon pay upi">Amazon pay upi</option>
                                        <option value="Axis Bank Pos">Axis Bank Pos</option>
                                        <option value="Phonepe - UCO Bank Pos">Phonepe - UCO Bank Pos</option>
                                        <option value="Card">Card</option>
                                        <option value="UPI">UPI</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 d-flex gap-2 justify-content-end">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => { handleReset(); onClose(); }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        // onClick={handleSubmit}
                                        onClick={async () => {
                                            if (!returnAmount.trim()) {
                                                Swal.fire('Error!', 'Please enter a Amount to return for the claim.', 'error');
                                                return;
                                            }
                                            if (!reason.trim()) {
                                                Swal.fire('Error!', 'Please enter a reason for the claim.', 'error');
                                                return;
                                            }
                                            try {
                                                const company = JSON.parse(localStorage.getItem('company'));
                                                const companyId = company?.company?.id;
                                                const response = await axios.post(`${API_URL}/bills/sales-bills/restock-old/${companyId}`, {
                                                    bill_id: bill.id,
                                                    variant_details: selectedOldSerials.map(s => ({
                                                        variant_id: s.variant_id,
                                                        serial_no: s.serial_no
                                                    })),
                                                    amount: returnAmount
                                                });
                                                if (response.data.message == 'Bill cancelled successfully' || response.data.message == 'Variant-wise return processed') {
                                                    handleSubmit();
                                                }
                                            } catch (err) {

                                                console.error(err);
                                            }
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Processing...' : 'Submit Claim'}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>


            </Modal>
        
        </>
    );
};

export default OtherClaimModal;